import { NavLink } from 'react-router-dom';
import { useMe } from '../../api/hooks';
import { veSeccion } from '../../auth/roles';

export function AlexiaNavigation() {
  const { data } = useMe();
  const user = data?.user;
  return <nav className="alexia-navigation" aria-label="Qué quieres hacer con Alexia">
    {user && (veSeccion(user, 'recetas') || veSeccion(user, 'gastos')) && <NavLink to="/chat">Cuéntame cómo lo haces</NavLink>}
    {user && veSeccion(user, 'asistente') && <NavLink to="/asistente">Analiza mi negocio</NavLink>}
  </nav>;
}
